/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_ZipInputs */

const cs_documents_zip = /** @type {(inputs: Documents_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP složky`)
};

const en_documents_zip = /** @type {(inputs: Documents_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip folder`)
};

/**
* | output |
* | --- |
* | "Zip folder" |
*
* @param {Documents_ZipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_zip = /** @type {((inputs?: Documents_ZipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_ZipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_zip(inputs)
	return cs_documents_zip(inputs)
});